const ruleChoices = [
  {
    value: 1,
    name: "Standard",
    description:
      "A balanced ruleset with no category prioritized over another.",
  },
  {
    value: 2,
    name: "Strength Focus",
    description:
      "A ruleset that gives more points to strength based exercises.",
  },
  {
    value: 3,
    name: "Cardio Focus",
    description: "A ruleset that gives more points to cardio based exercises.",
  },
  {
    value: 4,
    name: "Wellness Focus",
    description:
      "A ruleset that gives more points to wellness based exercises.",
  },
];

export default ruleChoices;
